import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { formatViewCountNumber } from 'src/app/helpers/format';
import { withInjectedStyles } from 'src/app/helpers/styles';

import { withLoginPopup } from 'src/app/helpers/login';
import { withToast } from 'src/app/helpers/toast';
import { InjectedLoginPopupProps } from 'src/app/models/login';
import { InjectedStylesProps } from 'src/app/models/styles';
import { InjectedToastProps } from 'src/app/models/toast';

import { ProgramSubscribeButton } from 'src/app/components/Program/ProgramSubscribeButton';

import { ProgramWithOverlay, ProgramWithSubscribe } from 'src/app/models/program';

type MyInjectedProps = InjectedToastProps & InjectedLoginPopupProps & InjectedStylesProps;

interface MyOwnProps extends ProgramWithOverlay {
  programPath: string;
  railAnalytics?: string;
  isLandscape?: boolean;
  className?: string;
}

type MyProps = MyOwnProps & MyInjectedProps;

@withToast()
@withLoginPopup()
@withInjectedStyles(require('./ProgramItemOverlay.desktop.scss'))
export class ProgramItemOverlayClass extends React.Component<MyProps> {
  render(): JSX.Element {
    const { programPath, name, totalVideoCount, totalViewCount, description, railAnalytics, className, isLandscape, isMobile } = this.props;
    const formattedViewCount = formatViewCountNumber(totalViewCount);

    return (
      <div className={classnames('program-item-overlay position-absolute d-none w-100 h-100 fld-column flex-1 d-none ', isMobile ? '' : className)}>
        <Link to={{ pathname: programPath, search: '?sortBy=NEWEST', state: { railAnalytics } }} className="flex-1 p-16 d-flex fld-column">
          <div className="flex-1 d-flex fld-column">
            <span className="flex-1"/>
            <span className="mb-8 fg-white fs-16 fw-700 lh-1 program-item-overlay__title">{name}</span>
            <div className="mb-8 fg-white fs-14 fw-500 lh-1">
              <FormattedMessage
                id="label.program.count.simple"
                values={{ videoCount: totalVideoCount, viewCount: formattedViewCount }}
              />
            </div>
            <span className={classnames('fs-14 fg-gray-light ', 'program-item-overlay__description'.concat(isLandscape ? '-landscape' : ''))}>{description}</span>
          </div>
        </Link>
        <span className="mb-16 mx-16">
          {this.renderedSubscribeButton}
        </span>
      </div>
    );
  }

  private get renderedSubscribeButton(): JSX.Element {
    const { isLandscape, openLoginPopup, showToast } = this.props;
    const buttonClassName = 'button@md--format-32 flex-1 tt-uppercase fs-12 ls-2 fg-white w-100 ' + (isLandscape ? 'program-item-overlay__button-landscape' : '');

    return (
      <ProgramSubscribeButton
        {...this.props as ProgramWithSubscribe}
        openLoginPopup={openLoginPopup}
        showToast={showToast}
        classname={buttonClassName}
      />
    );
  }
}

export const ProgramItemOverlay = ProgramItemOverlayClass as React.ComponentClass<MyOwnProps>;
